import * as gfunctions from '../../../js/generalFunctions';

CCL.guestEditConflicts = {
  autoload: [
    ['editGuestSaveBtnClick', $('.c-cart').length > 0],
    ['editGuestCancelBtnClick', $('.c-cart').length > 0],
    ['saveForLaterProduct_ShoreExBtnClick', $('.saveForLaterProduct_ShoreEx').length > 0],
    ['removeProduct_ShoreExBtnClick', $('.removeProduct_ShoreEx').length > 0],
    ['ExpandCollapseImg_timing', $('.conflict-panel-timing').length > 0],
    ['checkBoxClick', $('body').length > 0]
  ],


  redTextLenght: null,

  ExpandCollapseImg_timing() {
    $('body').on('click', '.conflict-panel-timing', (e) => {
      $(e.currentTarget).find('img:not(.tick-mark)').toggleClass('time-conflict-img-rotate');
    });
  },

  editGuestSaveBtnClick() {
    $('body').on('click', '.saveEditGuest_ShoreEx', (e) => {
      const productId = $(e.currentTarget).attr('data-productId');
      const parentElement = $(e.currentTarget).parents('.edit-guest-time-shorex-cart-wrap');
      const changedDiv = `.guest_${productId} .custom-checkbox`;
      const selecteditems = [];
      $(changedDiv).each((index, val) => {
        $(val).find('input:checked').each((i, ob) => {
          selecteditems.push(val.id);
        });
      });
      const productCard = gfunctions.getSelectedGuests(selecteditems);
      this.save_addToCartAjax(productId, productCard);
      $(e.currentTarget).parents('.cart-card-body').find('.edit-guest-time-shorex-cart-link').attr('aria-expanded', 'false');
      setTimeout(() => {
        parentElement.siblings('.edit-guest-time-shorex-cart-link').addClass('ada-element-focus');
        parentElement.siblings('.edit-guest-time-shorex-cart-link').focus();
      }, 700);
    });
  },

  async save_addToCartAjax(productId, ajaxData) {
    let jsonObjects = { productId, productCard: ajaxData };
    let token;
    let ajaxUrl = '';
    let reqContentType;
    let method = 'POST';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/cart-conflicts/cart-edit-guest-time.json';
      method = 'GET';
      jsonObjects = null;
    } else {
      ajaxUrl = '/shop/cart/shoreex/updateSelection';
      jsonObjects = JSON.stringify(jsonObjects);
      reqContentType = 'application/json';
      token = $('#csrfSessionToken').data('csrf');
    }
    gfunctions.showLoader();
    try {
      const inputDataObj = {
        url: ajaxUrl,
        type: method,
        data: jsonObjects,
        contentType: reqContentType,
        dataType: 'json',
        headers: {
          CSRFToken: token
        }
      };
      const res = await gfunctions.doAjax(inputDataObj);
      gfunctions.hideLoader();
      if (res.productCard) {
        this.showEditGuests(productId, res);
        gfunctions.updateCartSummary(res.orderSummary);
        gfunctions.updateProductSummary(res.orderSummary);
        gfunctions.updateCouponSummary(res);
        CCL.saveForLaterObj.loadSaveForLaterCartSection();
        if (res.cartEmpty) {
          window.location.reload();
        }
        console.log(`Something went well on Save Click for product ${productId}`);
      } else {
        $(`.card-${productId}`).css('display', 'none'); // remove the card from DOM if product card is null
        gfunctions.updateCartSummary(res.orderSummary);
        gfunctions.updateProductSummary(res.orderSummary);
        gfunctions.updateCouponSummary(res);
        if (res.cartEmpty) {
          window.location.reload();
        }
      }
    } catch (err) {
      const cartAPIError = { customError: err };
      gfunctions.hideLoader();
      console.log(`Something went wrong on Save Click for product ${productId}`);
      console.log(cartAPIError);
    }
  },

  saveForLaterProduct_ShoreExBtnClick() {
    $('body').on('click', '.saveForLaterProduct_ShoreEx', (e) => {
      const productId = $(e.currentTarget).attr('data-productId');
      const getProductDiv = `.card-${productId}`;
      // $(getProductDiv).css('display', 'none');
      // code has to be implemented based on scenario
    });
  },

  removeProduct_ShoreExBtnClick() {
    $('body').on('click', '.removeProduct_ShoreEx', (e) => {
      const productId = $(e.currentTarget).attr('data-productId');
      const getProductDiv = `.card-${productId}`;
      $(getProductDiv).css('display', 'none');
      this.removeBtn_ShoreEx_CartAjax(productId);
    });
  },

  removeBtn_ShoreEx_CartAjax(productId) {
    gfunctions.showLoader();
    const jsonObjects = { productId };
    const token = $('#csrfSessionToken').data('csrf');
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: '/shop/cart/shoreex/removeBaseProduct',
      data: JSON.stringify(jsonObjects),
      dataType: 'json',
      beforeSend: (xhr) => {
        xhr.setRequestHeader('CSRFToken', token);
      },
      success: (res) => {
        if (res.removeSuccess) {
          gfunctions.updateCartSummary(res.orderSummary);
          gfunctions.updateProductSummary(res.orderSummary);
          gfunctions.updateHeaderCartWidget(res);
          gfunctions.updateCouponSummary(res);
          this.showEditGuests(productId, res);
          // SAS Event for remove
          gfunctions.sasEvents('send', res.cclSasAnalyticsJsonData);
          if (res.cartEmpty) {
            window.location.reload();
          }
          console.log(`Something went well on Remove Click for ShoreEx product ${productId}`);
        } else {
          gfunctions.updateCartSummary(res.orderSummary);
          gfunctions.updateProductSummary(res.orderSummary);
          gfunctions.updateHeaderCartWidget(res);
          gfunctions.updateCouponSummary(res);
          if (res.cartEmpty) {
            window.location.reload();
          }
          $(`.card-${productId}`).css('display', 'block'); // Keep the card from DOM if RemoveSuccess is false
        }
        gfunctions.hideLoader();
      },
      error: (error) => {
        gfunctions.hideLoader();
        console.log(`Something went wrong on Remove Click for ShoreEx product ${productId}`);
      }
    });
  },

  editGuestCancelBtnClick() {
    $('body').on('click', '.cancelEditGuest_ShoreEx', (e) => {
      const productId = $(e.currentTarget).attr('data-productId');
      const parentElement = $(e.currentTarget).parents('.edit-guest-time-shorex-cart-wrap');
      const wishList2Entry = $(e.currentTarget).parents('.cart-card-body').find('.edit-guest-time-shorex-cart-link').data('wishlist2entry');
      this.cancel_addToCartAjax(productId, wishList2Entry);
      setTimeout(() => {
        parentElement.siblings('.edit-guest-time-shorex-cart-link').focus();
      }, 400);
    });
  },

  cancel_addToCartAjax(productId, wishList2Entry = false) {
    if (!wishList2Entry) {
      gfunctions.showLoader();
    }

    const jsonObjects = { productId, wishList2Entry };
    const token = $('#csrfSessionToken').data('csrf');
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: '/shop/cart/shoreex/productDetails',
      data: JSON.stringify(jsonObjects),
      dataType: 'json',
      beforeSend: (xhr) => {
        xhr.setRequestHeader('CSRFToken', token);
      },
      success: (res) => {
        this.showEditGuests(productId, res, wishList2Entry);

        if (!wishList2Entry) {
          gfunctions.updateCartSummary(res.orderSummary);
          gfunctions.updateProductSummary(res.orderSummary);
          gfunctions.updateCouponSummary(res);
          gfunctions.hideLoader();
          if (res.cartEmpty) {
            window.location.reload();
          }
        }
        console.log(`Something went well on Cancel click for product ${productId}`);
      },
      error: (error) => {
        gfunctions.hideLoader();
        console.log(`Something went wrong on Cancel click for product ${productId}`);
      }
    });
  },

  showEditGuests(productId, data, wishList2Entry = false) {
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/cart-conflicts/cart-edit-guest-time.html'
    }).done((response) => {
      const html = gfunctions.createDynamicHTML(response, data);
      const repanitClass = `.edit-guest-time-shorex-cart-wrap.guest_${productId}`;
      if (!wishList2Entry) {
        if ($(`.card-${productId} .cart-card-body .departureTimeSlots`).length && data.productCard.departureTimeSlots !== null) {
          $(`.card-${productId} .cart-card-body .departureTimeSlots`)[0].innerHTML = `${data.productCard.departureTimeSlots}`;
        }
      }
      if (repanitClass.length) {
        $(repanitClass).empty().append(html);
        if (!wishList2Entry) {
          const $imgArrowIcon = $(`.c-cart-card.card-${productId}`).find('.list-item.edit-guest-time-shorex-cart-link');
          $imgArrowIcon.removeClass('open');
          $(repanitClass).attr('style', 'display:none');
          this.updateSelectedGuestsCount(productId, data.qtyAdded);
        }
      }
      // call all javascript event after above html load
      const otherConflictsData = data.conflictingProductDetails;
      // repainting all the time slots which has conflicts
      $.each(otherConflictsData, (index, item) => {
        const conflictData = item;
        item.productCard = {};
        item.selectTimeAndGuest = 'SELECT TIME AND GUESTS';
        item.productCard.productId = item.productCode;
        const conflictHtml = gfunctions.createDynamicHTML(response, conflictData);
        const repaintDiv = `.edit-guest-time-shorex-cart-wrap.guest_${item.productCode}`;
        $(repaintDiv).empty().append(conflictHtml);
        const $ArrowIcon = $(`.c-cart-card.card-${item.productCode}`).find('.list-item.edit-guest-time-shorex-cart-link');
        $ArrowIcon.removeClass('open');
        $(repaintDiv).attr('style', 'display:none');
        // this.checkBoxClick();
      });

      if (wishList2Entry) {
        CCL.editCartStateroom.disableMoveToCart();
        $('.edit-guest-time-shorex-cart-wrap input[type="checkbox"]:checked:not(:disabled)').each((index, element) => {
          $(element).trigger('click');
          setTimeout(() => {
            $(element).trigger('click');
          }, 300);
        });
      }
      // this.checkBoxClick();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('Something went wrong while loading dynamic HTML');
    });
  },

  updateSelectedGuestsCount(productId, qtyAdded) {
    const userCntEl = $(`.quantity_${productId}`);
    userCntEl[0].textContent = qtyAdded;
  },

  checkBoxClick() {
    // $('.custom-checkbox').click((e) => {
    $('body').on('click', '.c-edit-guest-time-shorex-cart .custom-checkbox', (e) => {
      if (e.target.tagName === 'INPUT') {
        const currentID = e.target.id;
        const guestId = e.target.dataset.guestid;
        const $parentRoom = $(`#${currentID}`).parents('div.conflict-panel-timing');
        const $parentSection = $(`#${currentID}`).parents('div.c-cart-card');
        const ticketThreshold = Number($parentSection.data('ticketthreshold'));
        const $qtyAvailable = $parentRoom.find('.tickets-availability-text').text();

        const selectedStartTime = $parentRoom[0].dataset.starttime;
        const selectedEndTime = $parentRoom[0].dataset.endtime;
        // eslint-disable-next-line radix
        let qty = parseInt($qtyAvailable.split(' ')[0]);
        $parentRoom.find($('.custom-control.custom-checkbox > input[type="checkbox"]:checked')).each((index, element) => {
          if (element.hasAttribute('checked')) {
            element.removeAttribute('checked');
            element.checked = true;
          }
        });

        // if ($(`#${currentID}`).find('input').prop('checked')) {
        if ($(`#${currentID}`).prop('checked')) {
          qty--;
          $(`#${currentID}`).removeAttr('checked');
          //  $(`#${currentID}`).find('input').removeAttr('checked');
          $parentRoom.find('.tickets-availability-text').not('.redtext').text(`${qty} Tickets available`);
        } else {
          qty++;
          $parentRoom.find('.tickets-availability-text').not('.redtext').text(`${qty} Tickets available`);
        }

        if (qty > ticketThreshold) {
          $parentRoom.find('.tickets-availability-text').hide();
          $parentRoom.find('.threshold-ticket-text').text(`More than ${ticketThreshold} tickets available`).addClass('show');
        } else {
          $parentRoom.find('.tickets-availability-text').not('.redtext').text(`${qty} tickets available`).show();
          $parentRoom.find('.threshold-ticket-text').removeClass('show');
        }

        $parentRoom.find($('.custom-control.custom-checkbox > input[type="checkbox"]')).each((index, element) => {
          const redTextValue = $($(`#${element.parentElement.id}`).find('.redtext')).text();

          if (redTextValue === 'Sold Out' || redTextValue === '') {
            this.redTextLenght = false;
          } else {
            this.redTextLenght = true;
          }
          if (!this.redTextLenght) {
            if (!element.checked) {
              if (qty === 0) {
                element.disabled = true;
                element.parentElement.classList.add('div-disabled');
                if ($(`#${element.parentElement.id}`).find('span').hasClass('redtext')) {
                  $($(`#${element.parentElement.id}`).find('.redtext')).text('Sold Out');
                } else {
                  $(`#${element.parentElement.id}`).find('label').append($('<span class="redtext"></span>').text('Sold Out'));
                }
              } else {
                /* eslint-disable */
                if (!element.dataset.sameproductconflict || element.dataset.sameproductconflict === 'false') {
                  element.disabled = false;
                  element.parentElement.classList.remove('div-disabled');
                  $($(`#${element.parentElement.id}`).find('.redtext')).text('');
                }
                /* eslint-enable */
              }
            }
          }
        });

        $parentSection.find($('.conflict-panel-timing')).each((index, element) => {
          if (element.id !== $parentRoom[0].id) {
            const { istransferproduct, starttime, endtime } = element.dataset;
            if (istransferproduct === 'true') {
              if (!e.target.checked) {
                $(`#${element.id} .guest-${guestId}`).each((ind, ele) => {
                  const redTextValue = $($(`#${ele.parentElement.id}`).find('.redtext')).text();
                  if (!redTextValue.length) {
                    ele.disabled = false;
                    ele.parentElement.classList.remove('div-disabled');
                    ele.dataset.sameproductconflict = false;
                  }
                });
              } else {
                $(`#${element.id} .guest-${guestId}`).each((i, elem) => {
                  if (!elem.checked && elem.id !== currentID) {
                    elem.disabled = true;
                    elem.parentElement.classList.add('div-disabled');
                    elem.dataset.sameproductconflict = true;
                  }
                });
              }
            } else if (new Date(selectedEndTime) >= new Date(starttime)) {
              if (!e.target.checked) {
                $(`#${element.id} .guest-${guestId}`).each((ind, ele) => {
                  const redTextValue = $($(`#${ele.parentElement.id}`).find('.redtext')).text();
                  if (!redTextValue.length) {
                    ele.disabled = false;
                    ele.parentElement.classList.remove('div-disabled');
                    ele.dataset.sameproductconflict = false;
                  }
                });
              } else {
                $(`#${element.id} .guest-${guestId}`).each((i, elem) => {
                  if (!elem.checked && elem.id !== currentID && new Date(selectedStartTime) <= new Date(endtime)) {
                    elem.disabled = true;
                    elem.parentElement.classList.add('div-disabled');
                    elem.dataset.sameproductconflict = true;
                  }
                });
              }
            }
          }
        });
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-edit-guest-time-shorex-cart/edit-guest-time-cart.js